/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Harden_Detail6Inputs */

const en_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled runs, retries, and drift detection on the target sites.`)
};

const ar_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تشغيلات مجدولة ومحاولات واكتشاف الانحراف في المواقع المستهدفة.`)
};

const bn_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শিডিউলড রান, রিট্রাই ও টার্গেট সাইটে ড্রিফট ডিটেকশন।`)
};

const de_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplante Läufe, Wiederholungsversuche und Drifterkennung auf den Zielseiten.`)
};

const es_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecuciones programadas, reintentos y detección de deriva en los sitios de destino.`)
};

const fr_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécutions planifiées, tentatives et détection de dérive sur les sites cibles.`)
};

const pt_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execuções programadas, novas tentativas e detecção de desvios nos sites de destino.`)
};

const zh_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在目标站点上计划运行、重试和偏差检测。`)
};

const tr_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hedef sitelerde zamanlanmış çalıştırmalar, yeniden denemeler ve sapma tespiti.`)
};

const ru_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запланированные запуски, ретраи и детект дрейфа на целевых сайтах.`)
};

const pl_svc_web_scraping_harden_detail6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaplanowane uruchomienia, ponowne próby i wykrywanie dryfu w witrynach docelowych.`)
};

/**
* | output |
* | --- |
* | "Scheduled runs, retries, and drift detection on the target sites." |
*
* @param {Svc_Web_Scraping_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_harden_detail6 = /** @type {((inputs?: Svc_Web_Scraping_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_web_scraping_harden_detail6(inputs)
	if (locale === "de") return de_svc_web_scraping_harden_detail6(inputs)
	if (locale === "es") return es_svc_web_scraping_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_web_scraping_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_web_scraping_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_web_scraping_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_web_scraping_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_web_scraping_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_web_scraping_harden_detail6(inputs)
	return en_svc_web_scraping_harden_detail6(inputs)
});
export { svc_web_scraping_harden_detail6 as "svc_web-scraping_HARDEN_detail" }